module.exports = __webpack_public_path__ + "img/double_relay_off.06a3cc82.svg";